import { createGlobalStyle } from 'styled-components';

const fontSize = {
  'text-xs': '0.75rem', // 12px
  'text-sm': '0.875rem', // 14px
  'text-md': '1rem', // 16px
  'text-lg': '1.125rem', // 18px
  'text-xl': '1.25rem', // 20px
  'display-xs': '1.5rem', // 24px
  'display-sm': '1.875rem', // 30px
  'display-md': '2.25rem', // 36px
  'display-lg': '3rem', // 48px
  'display-xl': '3.75rem', // 60px
  'display-2xl': '4.5rem', // 72px
};
Object.freeze(fontSize);

const lineHeight = {
  'text-xs': '1.125rem', // 18px
  'text-sm': '1.25rem', // 20px
  'text-md': '1.375rem', // 22px
  'text-lg': '1.5rem', // 24px
  'text-xl': '1.75rem', // 28px
  'display-xs': '2rem', // 32px
  'display-sm': '2.375rem', // 38px
  'display-md': '2.75rem', // 44px
  'display-lg': '3.75rem', // 60px
  'display-xl': '4.5rem', // 72px
  'display-2xl': '5.625rem', // 90px
};
Object.freeze(lineHeight);

const fontWeight = {
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
};
Object.freeze(fontWeight);

const fontFamily = {
  body: 'Inter, Arial, sans-serif',
  display: 'InterTight, Arial, sans-serif',
};
Object.freeze(fontFamily);

const variables = {
  'font-size': fontSize,
  'line-height': lineHeight,
  'font-weight': fontWeight,
  'font-family': fontFamily,
};

const typographyGlobalVariables = Object.entries(variables)
  .map(([key, value]) =>
    Object.keys(value).map((subKey) => `--${key}-${subKey}: ${value[subKey as keyof typeof value]};`)
  )
  .flat();

export type FontSizePropKeys = `font-size-${keyof typeof fontSize}`;
export type LineHeightPropKeys = `line-height-${keyof typeof lineHeight}`;
export type FontWeightPropKeys = `font-weight-${keyof typeof fontWeight}`;
export type FontFamilyPropKeys = `font-family-${keyof typeof fontFamily}`;

export type TypographyPropKeys = FontSizePropKeys | LineHeightPropKeys | FontWeightPropKeys | FontFamilyPropKeys;

export { fontSize, lineHeight, fontWeight, fontFamily };

export const TypographyGlobalVariables = createGlobalStyle`
  :root {
    ${typographyGlobalVariables.join('\n')}
  }
`;
